import { Newsletter } from 'components/widget/newsletter/newsletter'
export default Newsletter
